export interface NotificationItem {
  name: string;
  enabled: boolean;
  label: string;
  description: string;
}

export const DefaultNotificationItems = [
  {
    name: 'computeTaskStatusUpdate',
    enabled: true,
    label: 'Compute Task Update',
    description:
      'Receive email notifications when your compute tasks change status, including FTP transfers and sample reconstructions.',
  },
  {
    name: 'sharingUpdate',
    enabled: true,
    label: 'Data & Project Sharing',
    description:
      'Receive email alerts when data or project sharing is modified—whether new sharing is granted or revoked.',
  },
  {
    name: 'dataExpiration',
    enabled: true,
    label: 'Data Expiration Alert',
    description:
      'Receive email reminders before your data expires and is scheduled for deletion, so you can take timely action.',
  },
];

export function reviseNotifications(
  fetched: NotificationItem[]
): NotificationItem[] {
  return DefaultNotificationItems.map((defaultItem) => {
    // Validate fetched is correctly typed and formatted, if not use default
    if (!fetched || !Array.isArray(fetched)) {
      console.warn(
        'Fetched notifications are not an array, using default items instead.'
      );
      return defaultItem;
    }
    // Validate the fetch item has name and enabled properties (enabled is boolean and can be false)
    if (!fetched.every((n) => n.name && typeof n.enabled === 'boolean')) {
      console.warn(
        'Fetched notifications are missing required properties, using default items instead.'
      );
      return defaultItem;
    }
    // Find the matching notification by name in the fetched list
    const fetchedItem = fetched.find((n) => n.name === defaultItem.name);
    return {
      name: defaultItem.name,
      label: defaultItem.label,
      description: defaultItem.description,
      // Use the fetched enabled value if available, otherwise the default
      enabled: fetchedItem ? fetchedItem.enabled : defaultItem.enabled,
    };
  });
}
